__turbopack_context__.v({
  "title": "subcategory-products-module__6hMMDG__title",
  "wrapper": "subcategory-products-module__6hMMDG__wrapper",
});
